<template>
  <div class="flex gap-1">
    <div class="shrink-0 w-60 border flex flex-col p-1.5">
      <el-button size="mini" class="w-full" type="primary" plain @click="init">
        New Model
      </el-button>
      <ul
        class="trigger-marker grow py-1 overflow-auto h-[calc(100vh_-_162px)]"
      >
        <li
          v-for="item in models"
          :key="item.id"
          class="flex items-center justify-between"
          :class="{ active: model.id == item.id }"
          @click="load(item)"
        >
          <div class="ellipsis">{{ item.name || item.filename }}</div>
          <div v-if="item.status" class="w-5 green">
            <svg
              :class="{ 'animate-spin': item.status == 'building' }"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
              ></path>
            </svg>
          </div>
          <div v-if="item.error" class="w-5 red">
            <svg
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              ></path>
            </svg>
          </div>
        </li>
      </ul>
    </div>
    <div class="grow flex gap-1">
      <div v-if="model.id != null" class="box shrink-0 w-[500px]">
        <div class="box-content -m-1.5">
          <el-tabs class="dense" v-model="activeTab">
            <el-tab-pane label="Current" name="current">
              <el-form
                label-position="top"
                size="mini"
                class="e-form overflow-auto h-[calc(100vh_-_180px)]"
                v-model="model"
              >
                <div class="flex items-center gap-1">
                  <el-form-item label="Name" class="w-1/2">
                    <el-input v-model="model.name" @change="save(model)" />
                  </el-form-item>
                  <el-form-item label="Schema">
                    <el-select
                      v-model="model.schema"
                      filterable
                      class="w-full"
                      @change="save(model)"
                    >
                      <el-option label="Intermodal" value="imdl" />
                      <el-option label="Truckload" value="tl" />
                      <el-option label="J1" value="tir" />
                      <el-option
                        label="Chassis Invoice"
                        value="chassis_invoice"
                      />
                      <el-option label="Carrier Rate" value="carrier_rate" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label=" ">
                    <el-checkbox
                      v-model="model.default"
                      border
                      @change="save(model)"
                    >
                      Default
                    </el-checkbox>
                  </el-form-item>
                </div>
                <el-form-item label="Prompt">
                  <el-input
                    v-model="model.prompt"
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 20 }"
                    @change="save(model)"
                  />
                </el-form-item>
                <el-form-item label="Customers (use regexp pattern)">
                  <el-input
                    v-model="model.customers"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 10 }"
                    @change="save(model)"
                  />
                </el-form-item>
                <el-form-item label="Trims (use regexp pattern)">
                  <el-input
                    v-model="model.trims"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 10 }"
                    @change="save(model)"
                  />
                </el-form-item>
                <el-form-item label="">
                  <el-button
                    @click="create(model)"
                    type="success"
                    v-if="model.id == 0"
                  >
                    Create Model
                  </el-button>
                  <el-popconfirm
                    title="Are you sure to save as a new version?"
                    @confirm="save(model, true)"
                    v-else
                  >
                    <el-button type="primary" slot="reference"
                      >Save Version</el-button
                    >
                  </el-popconfirm>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <slot v-if="model.id > 0">
              <el-tab-pane
                v-for="(version, index) in model.versions"
                :label="version.date"
                :name="`v${index + 1}`"
                :key="index"
              >
                <div class="box">
                  <div
                    class="box-title text-xs flex items-center justify-between"
                  >
                    <div>
                      {{ version.name }} /
                      {{ version.schema.toUpperCase() }}
                    </div>
                    <a class="no-underline" @click="remove(model, version)"
                      >Delete</a
                    >
                  </div>
                  <div
                    class="box-content overflow-auto h-[calc(100vh_-_220px)]"
                  >
                    <fieldset class="border">
                      <legend class="flex items-center gap-1">
                        <div>Prompt</div>
                        <e-copy :text="version.prompt" :size="16" />
                      </legend>
                      <textarea
                        class="text-xs w-full box-border bg-white h-[40rem]"
                        v-model="version.prompt"
                        :readonly="true"
                      />
                    </fieldset>
                    <fieldset class="border">
                      <legend>Customers</legend>
                      <textarea
                        class="text-xs bg-white h-24 w-full"
                        v-model="version.customers"
                        :readonly="true"
                      />
                    </fieldset>
                    <fieldset class="border">
                      <legend>Trims</legend>
                      <textarea
                        class="text-xs bg-white h-24 w-full"
                        v-model="version.trims"
                        :readonly="true"
                      />
                    </fieldset>
                  </div>
                </div>
              </el-tab-pane>
            </slot>
          </el-tabs>
        </div>
      </div>
      <DocumentAiModel
        :model="model"
        :models="models"
        @remove="remove"
        @save="save"
        @build="build"
        :key="model.id"
        v-if="model.id"
      />
    </div>
  </div>
</template>
<script>
import DocumentAiModel from "@/system/pages/document/ai/model.vue";
export default {
  name: "DocumentAi",
  components: {
    DocumentAiModel,
  },
  data() {
    return {
      model: {},
      models: [],
      activeTab: "current",
    };
  },
  mounted() {
    this.loadModels();
  },
  methods: {
    loadModels() {
      this.$http
        .get("/document/ai/models.json")
        .then((response) => {
          this.models = response.data;
        })
        .catch((err) => {});
    },
    init() {
      this.model = Object.assign({}, { id: 0 });
      this.activeTab = "current";
    },
    load(model) {
      this.$http
        .get(`/document/ai/models/${model.id}`)
        .then((response) => {
          let index = this.models.findIndex((o) => o.id == model.id);
          if (index >= 0) {
            this.models.splice(index, 1, response.data);
            this.model = this.models[index];
            this.activeTab = "current";
          }
        })
        .catch((err) => {});
    },
    create(model) {
      this.$http
        .post(`/document/ai/models`, { model })
        .then((response) => {
          this.models.push(response.data);
          this.load(response.data);
        })
        .catch((err) => {
          const errors = err.response.data.errors.join("; ");
          this.$message({ message: errors, type: "error" });
        });
    },
    save(model, version = false) {
      if (model.id == 0) return;
      this.$http
        .put(`/document/ai/models/${model.id}`, { model, version })
        .then((response) => {
          let index = this.models.findIndex((o) => o.id == response.data.id);
          if (index >= 0) this.models.splice(index, 1, response.data);
          this.load(response.data);
          this.$message({
            message: "The model was successfully saved.",
            type: "success",
          });
        })
        .catch((err) => {
          const errors = err.response.data.errors.join("; ");
          this.$message({ message: errors, type: "error" });
        });
    },
    remove(model, version = null) {
      const confirmation = version
        ? "Are you sure to delete this version?"
        : "Are you sure to delete this model?";
      this.$confirm(confirmation, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$http
          .delete(`/document/ai/models/${model.id}.json?version=${version.id}`)
          .then((response) => {
            if (version) {
              let index = model.versions.findIndex((o) => o.id == version.id);
              if (index >= 0) model.versions.splice(index, 1);
              this.$message({
                message: "The version was successfully deleted.",
                type: "success",
              });
              this.activeTab = "current";
            } else {
              let index = this.models.findIndex((o) => o.id == model.id);
              if (index >= 0) this.models.splice(index, 1);
              this.$message({
                message: "The model was successfully deleted.",
                type: "success",
              });
            }
          })
          .catch((err) => {
            const errors = err.response.data.errors.join("; ");
            this.$message({ message: errors, type: "error" });
          });
      });
    },
    build(model) {
      this.$confirm("Are you sure to build this model?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$set(this.model, "status", "building");
        this.$http
          .post(`/document/ai/models/${model.id}/build.json`)
          .then((response) => {
            this.load(model);
            this.$message({
              message: "The system is building the model at the background.",
              type: "success",
            });
          })
          .catch((err) => {
            this.$message({ message: err.response.data.errors, type: "error" });
          });
      });
    },
  },
};
</script>
